import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { titleCase } from "@/lib/format";

const MAP = [
  { re: /approv|accept|complete|delivered|active|saleable|paid|confirmed|closed|done|received|success|ok|pass/i,
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { re: /pending|draft|review|await|open|submitted|quarantine|hold|qa|in.?progress|processing/i,
    cls: "bg-amber-50 text-amber-800 border-amber-200" },
  { re: /reject|fail|cancel|expired|damaged|error|overdue|out.?of.?stock|declin/i,
    cls: "bg-rose-50 text-rose-700 border-rose-200" },
  { re: /ready|dispatch|shipped|new|created|low.?stock/i,
    cls: "bg-sky-50 text-sky-700 border-sky-200" },
];

export function StatusBadge({ value, className }) {
  if (value === null || value === undefined || value === "") return <span className="text-muted-foreground">—</span>;
  const str = String(value);
  const found = MAP.find((m) => m.re.test(str));
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${str.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={cn("font-medium border rounded-full px-2.5 py-0.5 text-[11px]", found?.cls || "bg-stone-100 text-stone-700 border-stone-200", className)}
    >
      {titleCase(str)}
    </Badge>
  );
}
